import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var buttonThemeNative = {
  color: 'primary',
  foregroundColor: 'background',
  disabled: {
    textColor: colors.fogGrey,
    backgroundColor: colors.lightGrey
  },
  plain: {
    background: 'transparent',
    foreground: 'transparent'
  },
  font: {
    size: 18
  },
  padding: 56,
  height: {
    s: 48,
    m: 56,
    l: 64
  },
  border: {
    width: 2,
    style: 'solid'
  }
};

var buttonDarkThemNative = _extends({}, buttonThemeNative, {
  disabled: {
    textColor: colors.emperorGrey,
    backgroundColor: colors.mineShaftGrey
  }
});

var buttonThemeWeb = {
  color: 'primary',
  disabledColor: colors.cloudGrey,
  borders: {
    radius: 'borders.radius',
    width: 2
  },
  font: {
    size: {
      s: 18,
      m: 18,
      l: 18
    },
    weight: {
      s: 400,
      m: 400,
      l: 400
    }
  },
  icon: {
    size: 24
  },
  height: {
    s: 48,
    m: 56,
    l: 64
  },
  paddings: {
    /**
     * text-in-the-middle always aligns text to middle, and possible icon to the side
     * balanced centers icon and the text, so that same amount of space is left to both sides
     */
    mode: 'text-in-middle',

    /**
     * Text-in-middle: Padding between the border and the possible icon
     * Balanced: Padding between the content and the border
     */
    fromSide: 16,

    /**
     * Padding between the icon and the text
     */
    afterIcon: 16,

    /**
     * Padding used for plain buttons
     */
    plain: 26,

    /**
     * Padding applied to button element
     */
    top: 0,

    /**
     * Padding applied to button element
     */
    bottom: 0
  },
  margins: {
    text: {
      /**
       * Use this to correct text vertical position
       */
      top: 0
    }
  }
};

var buttonDarkThemeWeb = _extends({}, buttonThemeWeb, {
  disabledColor: colors.mineShaftGrey
});

export { buttonDarkThemNative, buttonDarkThemeWeb, buttonThemeNative, buttonThemeWeb };